import { useEffect, useState } from "react";
import type { Nullable } from "../@types/generic";
import { getWindow } from "../helpers/getWindow";

type BreakpointType = "mobile" | "tablet" | "desktop";
type UseViewportInformation = Nullable<{
    viewportWidth: number;
    // viewportHeight: number;
    breakpointType: BreakpointType;
}>;

export const useViewportInformation = (): UseViewportInformation => {
    const window = getWindow();
    const [viewportInformation, setViewportInformation] =
        useState<UseViewportInformation>(null);

    useEffect(() => {
        if (!window) {
            return;
        }

        const updateViewportInformation = (): void => {
            const viewportWidth = window.innerWidth;
            let breakpointType: BreakpointType = "mobile";

            if (viewportWidth >= 768) {
                breakpointType = "desktop";
            } else if (viewportWidth >= 426) {
                breakpointType = "tablet";
            }

            setViewportInformation((prev) => {
                if (
                    prev?.viewportWidth === viewportWidth &&
                    prev?.breakpointType === breakpointType
                ) {
                    return prev;
                }

                return {
                    viewportWidth,
                    breakpointType,
                };
            });
        };

        const resizeObserver = new ResizeObserver(() => {
            updateViewportInformation();
        });
        resizeObserver.observe(document.documentElement);

        return (): void => {
            resizeObserver.disconnect();
        };
    }, [window]);

    return viewportInformation;
};
